import Axios from 'axios';
import getCSRFToken from './getCSRFToken';

export const axiosAPIClient = Axios.create({
  baseURL: API_URL,
  headers: {
    'Authorization': `Bearer ${JWT_TOKEN}`,
    'X-Real-User': REAL_USER_UUID ?? '',
  },
  params: {
    lang: lang,
  },
});

export const axiosPortalClient = Axios.create({
  // TransformRequest MUST NOT be overwritten, as it contains the default transformer that handles JSON serialization
  transformRequest: [(data, headers) => {
    const presetToken = getCSRFToken();
    if (!presetToken) {
      console.log('csrfToken could not be read.');
      return data;
    }

    headers['X-CSRF-Token'] = presetToken;
    return data;
  }, ...Axios.defaults.transformRequest],
  headers: { 'X-CSRF-Token': `Bearer ${JWT_TOKEN}` },
  params: { lang },
});

export const axiosGoogleClient = Axios.create({
  baseURL: 'https://maps.googleapis.com/maps/api/geocode/json',
  params: { key: 'AIzaSyCKf1ysdlG-bSbw1sKxACmP6ohUU3ee64k' },
});

export const axiosTranslationServiceClient = Axios.create({
  baseURL: TRANSLATION_SERVICE_URL,
  headers: { authorization: `Bearer ${JWT_TOKEN}` },
});

export { default as axios } from 'axios';
